<template>
    <div class="chat-window">
      <div class="chat-header">
        <span>{{ chat.user.name }}</span>
      </div>
  
      <div class="messages">
        <div v-for="(message, index) in chat.messages" :key="index" class="message">
          <span>{{ message.sender }}: {{ message.text }}</span>
        </div>
      </div>
  
      <div class="chat-input">
        <input v-model="newMessage" type="text" placeholder="Type a message..." />
        <button @click="sendMessage">Send</button>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref } from 'vue';
  
  // Props passed from parent (Chats.vue)
  defineProps({
    chat: Object,  // Chat object that contains conversation details
  });
  
  const newMessage = ref('');
  
  // Handle sending a new message
  const sendMessage = () => {
    if (newMessage.value.trim()) {
      chat.messages.push({ sender: 'Me', text: newMessage.value });
      newMessage.value = '';
    }
  };
  </script>
  
  <style scoped>
  .chat-window {
    border: 1px solid #ddd;
    padding: 20px;
    max-width: 600px;
    margin: 0 auto;
  }
  
  .chat-header {
    font-size: 1.5rem;
    font-weight: bold;
  }
  
  .messages {
    margin-top: 20px;
    max-height: 300px;
    overflow-y: auto;
  }
  
  .message {
    margin: 10px 0;
  }
  
  .chat-input {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }
  
  .chat-input input {
    width: 80%;
    padding: 10px;
    border-radius: 5px;
  }
  
  .chat-input button {
    width: 15%;
    padding: 10px;
    border-radius: 5px;
    background-color: #007bff;
    color: white;
    border: none;
    cursor: pointer;
  }
  </style>
  